import { date } from "../../lib/format";
import { t } from "../../lib/sprache";

/** Stand der Meta-Datennutzungsprüfung (public.platform_meta_checkup, 0573) */
export interface MetaPruefung { last_on: string | null; due_on: string | null; days_left: number | null; attention: boolean }

/** „Zuletzt am 05.11.2025, fällig am 05.11.2026 (in 12 Tagen).“ */
export function metaPruefungSatz(s: MetaPruefung): string {
  if (!s.last_on || !s.due_on || s.days_left === null) return t("Noch kein Datum eingetragen. Bitte die letzte Prüfung eintragen.", "No date entered yet. Please enter the last checkup.");
  const zuletzt = t(`Zuletzt am ${date(s.last_on)}`, `Last on ${date(s.last_on)}`);
  if (s.days_left < 0) return t(`${zuletzt}, seit ${date(s.due_on)} überfällig (${-s.days_left} Tage).`, `${zuletzt}, overdue since ${date(s.due_on)} (${-s.days_left} days).`);
  if (s.days_left === 0) return t(`${zuletzt}, heute fällig.`, `${zuletzt}, due today.`);
  return t(`${zuletzt}, fällig am ${date(s.due_on)} (in ${s.days_left} ${s.days_left === 1 ? "Tag" : "Tagen"}).`, `${zuletzt}, due on ${date(s.due_on)} (in ${s.days_left} ${s.days_left === 1 ? "day" : "days"}).`);
}
